import Button from "components/base/Button";
import ProgressBar from "components/base/ProgressBar";
import { useModals } from "ModalProvider";
import moment from "moment";
import KeyResultForm from "./KeyResultForm";
import KeyResultView from "./KeyResultView";
import ObjectiveForm from "./ObjectiveForm";
import { computeProgress } from "./progress";

const ObjectiveView = ({ objective, index }) => {
  const modal = useModals();

  function addKeyResult() {
    modal.present({
      title: "Add Key Result",
      center: true,
      children: <KeyResultForm objectiveId={objective.id} hide={modal.hide} />,
    });
  }

  function editObjective() {
    modal.present({
      title: "Edit Objective",
      center: true,
      children: (
        <ObjectiveForm originalObjective={objective} hide={modal.hide} />
      ),
    });
  }

  const progress = computeProgress(objective);

  const keyResults = [...objective.keyResults].sort(
    (a, b) => a.dueQuarter - b.dueQuarter,
  );

  return (
    <div>
      <div className="flex justify-between items-baseline space-x-4">
        <h5>
          <Button onClick={editObjective}>
            {index + 1}. {objective.description}
          </Button>
        </h5>
        <div className="mt-2 whitespace-nowrap">
          🗓️ {moment(objective.dueDate).format("YYYY-MM-DD")}
        </div>
      </div>

      {objective.keyResults.length > 0 && (
        <div className="mt-2">
          <div className="mb-1 opacity-70">Progress</div>
          <ProgressBar value={progress} />
        </div>
      )}

      {objective.notes && (
        <div className="mt-1">
          <div className="opacity-70">Main Challenge</div>
          <div className="whitespace-pre-wrap">{objective.notes}</div>
        </div>
      )}

      <div className="mt-4">
        <div className="flex items-center justify-between">
          <div className="opacity-70">Key Results</div>
          <div>
            <Button onClick={addKeyResult}>+ Add Key Result</Button>
          </div>
        </div>
        <div className="mt-2">
          {objective.keyResults.length === 0 && (
            <div className="opacity-70">
              No key results yet. Please add one.
            </div>
          )}

          {keyResults.map((keyResult, index) => (
            <KeyResultView key={index} keyResult={keyResult} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectiveView;
